import { faCheck, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import CheckIcon from '../../assets/images/icons/check.svg';
import CrossIcon from '../../assets/images/icons/cross.svg';
import '../../assets/stylesheets/components/event-status-indicator.scss';
import { EventStatus as EventStatusEnum } from '../../enums';
import { colorScheme } from '../../theme';

interface EventStatusIndicatorProps {
  status: EventStatusEnum | boolean | null;
}
// TODO: replace with new indicator component
export function EventStatusIndicator(props: EventStatusIndicatorProps) {
  const { t } = useTranslation('events_common');
  const { status } = props;

  if (status === EventStatusEnum.approved || status === true) {
    const approved = t('review_status.approved');
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">{approved}</Tooltip>}>
        <CenteredIcon className="fa-check" icon={faCheck} title={approved} style={{ color: colorScheme.approve }} aria-label={approved} />
      </OverlayTrigger>
    );
  }
  if (status === EventStatusEnum.rejected || status === false) {
    const rejected = t('review_status.rejected');
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">{rejected}</Tooltip>}>
        <CenteredIcon className="fa-check" icon={faTimes} title={rejected} style={{ color: colorScheme.reject }} aria-label={rejected} />
      </OverlayTrigger>
    );
  }
  if (status === EventStatusEnum.approved_warning) {
    const warned = t('review_status.warned');
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">{warned}</Tooltip>}>
        <CenteredIcon icon={faExclamationTriangle} title={warned} style={{ color: colorScheme.warning }} aria-label={warned} />
      </OverlayTrigger>
    );
  }
  return null;
}

export function EventStatusIndicatorWithText(props: EventStatusIndicatorProps) {
  const { t } = useTranslation('events_common');
  const { status } = props;
  let toolTipText: string;
  let iconElement: any;

  if (status === EventStatusEnum.approved || status === true) {
    toolTipText = t('review_status.approved');
    iconElement = <img src={CheckIcon} className="hdn-event__status--icon" alt="✓" />;
  } else if (status === EventStatusEnum.rejected || status === false) {
    toolTipText = t('review_status.rejected');
    iconElement = <img src={CrossIcon} className="hdn-event__status--icon" alt="✗" />;
  } else {
    toolTipText = t('review_status.unreviewed');
    iconElement = <span className="hdn-event__status--icon">?</span>;
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="t">{toolTipText}</Tooltip>}>
      <div className="hdn-event__status">
        {iconElement}
        <span className="hdn-event__status--label"> {t('review_status.internal')}</span>
      </div>
    </OverlayTrigger>
  );
}

const CenteredIcon = styled(FontAwesomeIcon)`
  text-align: center;
  display: inline-block;
`;
